import { connect } from 'react-redux';
import { compose, AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { goToPlacesSearch } from 'common/src/app/actions/resources/geoLocationActions';
import { getApiNoCache } from 'common/src/app/actions/externalApiActions';
import { POSTCODE_IO_PLACES } from 'common/src/app/data/externalApis';

import NearestGroupPlacesLanding from './NearestGroupPlacesLanding';
import { DispatchProps, OwnProps } from './NearestGroupPlacesLanding.types';

type AppDispatch = ThunkDispatch<unknown, unknown, AnyAction>;

const mapDispatchToProps = (dispatch: AppDispatch, ownProps: OwnProps): DispatchProps => {
  const placeQuery = ownProps.location.query.place ?? '';
  return {
    getPlaces: () => dispatch(getApiNoCache(POSTCODE_IO_PLACES, placeQuery)),
    goToPlaces: (latitude, longitude, placeName) =>
      goToPlacesSearch(latitude, longitude, placeName, dispatch),
  };
};

const connector = connect<unknown, DispatchProps, OwnProps>(null, mapDispatchToProps);

export default compose<React.ComponentType<OwnProps>>(connector)(NearestGroupPlacesLanding);
